export const DEFAULT_COLLAPSE_THRESHOLD = 1000


